import { BASE_URL } from 'constants/api';

import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  PATCH: 'DEMO_FEEDBACK_PATCH',
  PATCH_SUCCESS: 'DEMO_FEEDBACK_PATCH_SUCCESS',
  PATCH_FAILURE: 'DEMO_FEEDBACK_PATCH_FAILURE',
  GET: 'DEMO_FEEDBACK_GET',
  GET_SUCCESS: 'DEMO_FEEDBACK_GET_SUCCESS',
  GET_FAILURE: 'DEMO_FEEDBACK_GET_FAILURE',
};

export const get = actions.get(
  (studentClassroomId, query) =>
    `${BASE_URL}/student-classrooms/${studentClassroomId}/demo-feedback/?${stringify(
      query,
    )}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(
  studentClassroomId =>
    `${BASE_URL}/student-classrooms/${studentClassroomId}/demo-feedback/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
